import { Component, effect, OnInit, signal, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from "src/app/popup/popup.component";
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import Swal from 'sweetalert2';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,FormsModule, Validators,ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BillingAdjustmentStatusEnumDisplay } from 'src/utilities';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MsalService } from '@azure/msal-angular';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { BillingAdjustmentStatusEnum, EmptyFallbackPipe, formatMoney, isNullOrEmptyOrWhitespace } from 'src/utilities';


@Component({
    selector: 'app-bulk-request-approval-dashboard',
    imports: [FormsModule, MatDatepickerModule, MatDateRangeInput, MatSelectModule, MatError, MatNativeDateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, PopupComponent, CommonModule, MatProgressSpinnerModule, NgxSpinnerModule, MatTableModule, MatIconModule, SharedModule, NgxSpinnerModule],
    templateUrl: './bulk-request-approval-dashboard.component.html',
    styleUrl: './bulk-request-approval-dashboard.component.scss'
})
export class BulkRequestApprovalDashboardComponent implements OnInit {
  @ViewChild('template1') template1: TemplateRef<any>; 
  selectedData: any;
  isGoodWillRequest: boolean = false;
  dialogRef: any;
  chooseDialogRef: any;
  isLoader: boolean = true;
  isDetailView = false;
  detailData: any[] = [];
 

 // ✅ Used for master table display
  readonly mainTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    { label: 'Total Customers', propertyName: 'customerCount' },
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'Description', propertyName: 'descriptionComment' },
    { label: 'Amount', propertyName: 'adjNetAmount' },
    { label: 'Special Instructions', propertyName: 'specialInstructions' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Requester', propertyName: 'requestor' },
    //{ label: 'Mi Remarks', propertyName: 'rejectionReason' },
    
       {
      label: 'Action', propertyName: 'icon',
      icons: [{ toolTip: 'Accept/Reject', icon: 'gavel', callFrom: 'acc/rej'},
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'viewDetails' },
      { toolTip: 'Download Files', icon: 'download' , callFrom:'download'},
      ]
    }
  ];

  // ✅ Used for detail table display
  readonly detailTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    // { label: 'Details Id', propertyName: 'detailsId' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'customerName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    { label: 'Check Request', propertyName: 'checkRequest' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    { label: 'Adjustment Method', propertyName: 'adjustmentMethod' },
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'firstLevelApprover' },
    { label: 'MI Remarks', propertyName: 'firstLevelRemarks' },
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'gbsRemarks' },
  ];

 invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
  checked: boolean = true;
  dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);
  firstFormGroup: FormGroup;
  panels: any[] = [];
  isLoading: boolean = false;
  isAccepted=signal<'accept' | 'reject' | 'needMoreInfo'>('accept');


  constructor(
    private modalService: BsModalService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private bulkRequestService: BulkRequestService,
    private msalService: MsalService,
    
  ) { }

  

  ngOnInit(): void {
    this.getAdjustmentDetails()
    this.firstFormGroup =new FormGroup({
     reason: new FormControl("",{
      nonNullable: true,
      validators: [Validators.maxLength(1000),Validators.pattern(/^(?!\s*$)[a-zA-Z0-9\s!@#$%^&*()_+={}\[\]|\\:;'"<>,.?/-`~|-]*$/)]
     })
   });
    effect(()=>
  {
    if (this.isAccepted() ==='reject' || this.isAccepted() ==='needMoreInfo')
    {
      this.firstFormGroup.get('reason')?.addValidators([Validators.required]);
      this.firstFormGroup.get('reason')?.updateValueAndValidity();
    }
    else
    {
      this.firstFormGroup.get('reason')?.removeValidators([Validators.required]);  
      this.firstFormGroup.get('reason')?.updateValueAndValidity();
    }
  });
   }
 



   openAcceptOrRejectDialog(e) {
    this.selectedData = e.details;
        if (e.callFrom == 'acc/rej') {
      this.chooseDialogRef = this.modalService.show(this.template1, { backdrop: "static" , class: 'template1-modal', });
    } 
    else if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
          else if (e.callFrom === 'viewDetails') {
  this.isDetailView = true;
  this.loadDetailsByAdjReqId(e.details.adjReqId);
}
  }


   
  getAdjustmentDetails(): void {
  this.spinner.showSpinner();

  this.bulkRequestService.getPendingBulkRequests(1).subscribe({
    next: response => {
      const data = response;

      if (Array.isArray(data) && data.length > 0) {
        data.forEach(x => {
          x.adjRequestDate = formatDate(x.adjRequestDate, 'MM/dd/yyyy', 'en-US');
        });

        this.dataSource.data = data;
      } else {
        this.dataSource.data = [];
        this.toastr.warning("No pending adjustments found.", "Notice");
      }

      this.isLoader = false;
      this.spinner.hideSpinner();
    },
    error: err => {
      this.spinner.hideSpinner();
      this.toastr.error("Failed to load adjustment details", "Error");
    }
  });
}

 
   closePopup() {
     if (this.dialogRef) {
      this.dialogRef.hide();
      this.isAccepted.set('accept');
    }
   }
 
   closePopup1()
   {
     if (this.chooseDialogRef)
       {
         this.chooseDialogRef.hide();
         this.firstFormGroup.reset({ reason: '' });
         this.isAccepted.set('accept');
       }
   }
 
   onNext(): void {
     if (this.firstFormGroup.invalid) {
       this.firstFormGroup.markAllAsTouched(); 
       return;
     }
     this.spinner.showSpinner();
     this.isLoading = false;
     const reason = this.firstFormGroup.get('reason')?.value ?? '';
     // const status = this.isAccepted ? 2 : 4;
     let status=5;
     if (this.isAccepted()=='accept'){
        status=5;
     }
     else if(this.isAccepted()  =='reject'){
       status=4;
     }
     else{
       status=3;
     }
     const payload = {
    adjReqId: this.selectedData.adjReqId,
    statusId: status,
    updatedBy: this.msalService.instance.getActiveAccount()?.username ?? 'system',
    rejectionReason: reason? reason : '',
  };

  this.bulkRequestService.updateBulkRequestStatus(payload).subscribe({
    next: (response) => {
      this.spinner.hideSpinner();
      this.isLoading = false;
      this.closePopup1();

      if (response === 2) {
        Swal.fire({
          title: "Status Updated Successfully.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      } else if (response === 1) {
        Swal.fire({
          title: "Request has already been processed. Refreshing the page.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      } else {
        Swal.fire({
          title: "Error Occurred.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }

      this.getAdjustmentDetails(); // Refresh the list
    },
    error: (err) => {
      this.spinner.hideSpinner();
      this.isLoading = false;
      Swal.fire({
        title: "API Error",
        text: err?.message || "Something went wrong.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  });
   }
  loadDetailsByAdjReqId(adjReqId: number): void {
    this.spinner.showSpinner();
    const notYetStatuses = [1,2,3,4,5,14,15];
    this.bulkRequestService.getBulkUploadDetailsByAdjReqId(adjReqId).subscribe({
      next: (data) => {
        data.forEach(x => {
                  x.gbsStatus = x.isGBSNMF
                                    ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
                                     notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
                                  if (
                                  (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
                                  (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
                                ) {
                                  x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
                                } else {                                 
                                  if(x.statusId==1){
                                    x.status = '--'
                                  }else{
                                    x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                                  }             
                  
                                }   
                });
        this.detailData = data || [];
        this.invoiceDataSource.data = this.detailData;
      },
      error: (err) => {
        console.error('Failed to load details:', err);
      },
      complete: () => this.spinner.hideSpinner()
    });
  }

  backToDashboard() {
  this.isDetailView = false;
  this.getAdjustmentDetails();
}
 
   showTooltip = false;
   tooltipSvg = `
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
     <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
     <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
     <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
     <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
   </svg>
 `;
 }
 
 